import { render, staticRenderFns } from "./RecruitmentCenter.vue?vue&type=template&id=c71d1cae&"
import script from "./RecruitmentCenter.vue?vue&type=script&lang=js&"
export * from "./RecruitmentCenter.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentCenter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports